import React from "react";
import { Accordion } from "@mui/material";

const DSAccordion = (props: React.ComponentProps<typeof Accordion>) => {
  return <Accordion {...props} />;
};

export default DSAccordion;
